<script setup lang="ts">
  import IconQC from '@qicgroupdoha/qic-connect-ds/components/IconQC'

  interface Props {
    icon: string
    text: string
  }

  defineProps<Props>()
</script>

<template>
  <div class="information-block">
    <!-- @vue-ignore -->
    <IconQC :name="icon" size="lg" :color="$qicConnect.colors.icn.srf.primary" />
    <span class="heading-6">{{ text }}</span>
  </div>
</template>

<style lang="scss" scoped>
  .information-block {
    display: flex;
    align-items: center;
    gap: var(--spacing-3);
  }
</style>
